import RemissionNoteCrud from "../components/remission-note/RemissionNoteCrud";

const RemissionNotesPage = () => {
  return <RemissionNoteCrud />;
};

export default RemissionNotesPage;
